// Mirrors the server-side check in InvoiceDeliverySettingController.Put; keep the messages identical.
export const getSenderNameError = (name: string | null | undefined): string => {
  if (!name || !name.trim()) return 'Sender name is a required field.';
  if (name.includes('@')) {
    return "Sender name can't contain an email address. Enter the name recipients should see, such as your firm name.";
  }
  if (/[<>"\r\n]/.test(name))
    return 'Sender name can\'t contain <, >, " or line breaks.';
  if (name.length > 100)
    return "Sender name can't be longer than 100 characters.";
  return '';
};

// The company name is the default the settings page already pre-fills for an empty name.
// null means neither is a name the API will accept.
export const senderNameOrCompanyName = (
  stored: string | null | undefined,
  companyName: string | null | undefined,
): string | null => {
  if (!getSenderNameError(stored)) return stored as string;
  if (!getSenderNameError(companyName)) return companyName as string;
  return null;
};
